import { normalizeUrl } from "./normalizeUrl";

export const UTM_FIELDS = [
  {
    key: "utm_source",
    label: "유입 출처",
    example: "instagram",
    required: true,
  },
  { key: "utm_medium", label: "유입 매체", example: "social", required: true },
  {
    key: "utm_campaign",
    label: "캠페인 이름",
    example: "autumn_launch",
    required: true,
  },
  {
    key: "utm_content",
    label: "콘텐츠 구분",
    example: "profile_link",
    required: false,
  },
  {
    key: "utm_term",
    label: "검색어",
    example: "brand_keyword",
    required: false,
  },
] as const;
export type UtmValues = Record<(typeof UTM_FIELDS)[number]["key"], string>;
export const EMPTY_UTM: UtmValues = {
  utm_source: "",
  utm_medium: "",
  utm_campaign: "",
  utm_content: "",
  utm_term: "",
};
export const MAX_BATCH = 50;

// Only supplied values replace matching UTM keys; unrelated queries and hashes survive.
export function withUtm(input: string, utm?: UtmValues): string | null {
  const normalized = normalizeUrl(input);
  if (!normalized) return null;
  const url = new URL(normalized);
  if (utm)
    UTM_FIELDS.forEach(({ key }) => {
      if (utm[key].trim()) url.searchParams.set(key, utm[key].trim());
    });
  return url.toString();
}

export function parseLinks(input: string): { line: number; value: string }[] {
  return input
    .split(/\r?\n/)
    .map((value, i) => ({ line: i + 1, value: value.trim() }))
    .filter((row) => row.value);
}

export async function shortenLink(originalURL: string): Promise<string> {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 30000);
  try {
    const response = await fetch("https://api.short.io/links/public", {
      method: "POST",
      headers: {
        Authorization: "pk_HAHXnDyeCeQL9Mjb",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        domain: "link.weplet.com",
        originalURL,
        allowDuplicates: true,
      }),
      signal: controller.signal,
    });
    if (!response.ok) {
      if (response.status === 429)
        throw new Error("요청 한도에 도달했습니다. 잠시 후 다시 시도해주세요.");
      throw new Error(`링크를 생성하지 못했습니다. (오류 ${response.status})`);
    }
    const data = await response.json();
    const url = normalizeUrl(data.secureShortURL || data.shortURL || "");
    if (!url)
      throw new Error(
        "올바른 링크를 받지 못했습니다. 생성 여부를 확인한 후 다시 시도해주세요.",
      );
    return url;
  } catch (error) {
    if (error instanceof Error && error.name === "AbortError") {
      throw new Error(
        "응답 시간이 초과되었습니다. 이미 생성되었을 수 있으니 확인 후 다시 시도해주세요.",
      );
    }
    if (error instanceof TypeError)
      throw new Error(
        "연결을 확인해주세요. 이미 생성되었을 수 있으니 확인 후 다시 시도해주세요.",
      );
    throw error;
  } finally {
    window.clearTimeout(timeout);
  }
}
